import classNames from 'classnames';
import React from 'react';

interface Props {
  children?: React.ReactNode;
  className?: string;
  text: string;
}

const Tooltip: React.FC<Props> = ({ children, className, text }) => {
  return (
    <div
      className={classNames(
        {
          tooltip: true,
        },
        className
      )}
    >
      <span>{children}</span>
      <div className="tooltip-content">{text}</div>
    </div>
  );
};

export default Tooltip;
